import { gql } from "@apollo/client";

export const GENERATE_CB_TOKEN = gql`
  mutation generateCBToken {
    generateCBToken
  }
`;

export const CANCEL_CB_TOKEN = gql`
  mutation cancelCBToken {
    cancelCBToken
  }
`;
